/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Users_Form_Clients_Selected_BadgeInputs */

const en_users_form_clients_selected_badge = /** @type {(inputs: Users_Form_Clients_Selected_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const pt_br2_users_form_clients_selected_badge = /** @type {(inputs: Users_Form_Clients_Selected_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selecionado(s)`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Users_Form_Clients_Selected_BadgeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_clients_selected_badge = /** @type {((inputs: Users_Form_Clients_Selected_BadgeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Clients_Selected_BadgeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_clients_selected_badge(inputs)
	return pt_br2_users_form_clients_selected_badge(inputs)
});